<template>
    <div class="not-found-container" :style="containerHeight">
        <div class="not-found-content">
            <div class="not-found-title">
                404
            </div>
            <div class="not-found-description">
                {{ notFoundText }}
            </div>
            <router-link
                :to="{ name: 'portal-main' }"
                type="button"
                class="red-button not-found-button"
            >
                Вернуться на главную
            </router-link>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

const getters = ['isMobile', 'height', 'headerHeight'];

export default {
    name: 'PageNotFound',

    props: {
        notFoundText: {
            type: String,
            default: 'Страница не найдена',
        },
    },

    computed: {
        ...mapGetters(getters),

        containerHeight() {
            const height = this.height - this.headerHeight;
            return { height: `${height}px` };
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.not-found {
    &-container {
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
        width: 100%;
        background-color: #f1f6fb;
    }

    &-content {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        width: rem(974);
        height: rem(734);
        background: url('~@/assets/images/404/404_bg.svg') no-repeat
            center/cover;

        @include on-mobile {
            width: mrem(375);
            height: mrem(381);
            background-image: url('~@/assets/images/404/404_mobile_bg.svg');
        }
    }

    &-title {
        font-family: 'Proxima Nova', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: rem(160);
        line-height: rem(195);
        text-align: center;
        color: #2a2626;

        @include on-mobile {
            font-size: mrem(80);
            line-height: mrem(97);
        }
    }

    &-description {
        margin: 0 0 rem(32) 0;
        font-family: 'Proxima Nova', sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: rem(40);
        line-height: rem(49);
        text-align: center;
        color: #2a2626;

        @include on-mobile {
            margin: 0 0 mrem(32) 0;
            font-size: mrem(22);
            line-height: mrem(30);
        }
    }

    &-button {
        width: rem(256);

        @include on-mobile {
            width: mrem(256);
        }
    }
}
</style>
